import React from 'react';
import classNames from 'classnames';

export default function Spinner({ className, inline }) {
  const classes = {
    'lds-circle': true,
    'lds-circle--block': !inline,
    'lds-circle--inline': inline,
  };
  if (className) classes[className] = true;

  return (
    <div className={classNames(classes)}>
      <div className="lds-circle__inner" />
    </div>
  );
}